/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @file FileDownloadUtils.js
 * @author Gladson Samuel S
 * @description Utility functions for downloading files
 */

/**
 * Downloads a CSV file
 *
 * @param {string} content - The content of the CSV file
 * @param {string} filename - The name of the CSV file
 */
export function downloadCsvFile(content, filename) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const objectUrl = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');

  downloadLink.href = objectUrl;
  downloadLink.download = filename;
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(objectUrl);
}

/**
 * Joins the given name segments into a CSV filename, skipping any that are empty
 *
 * @param {...string} segments - Filename segments, already sanitized by the caller
 * @returns {string} The filename
 */
export function buildExportFilename(...segments) {
  const filename = segments.filter(Boolean).join('-');

  return `${filename || 'export'}.csv`;
}
